import React, { useCallback, useEffect, useState } from "react";
import api from "../../Utils/api";
import { hasPermission } from "../../Utils/permissions";

export default function ListaBoletins() {
  const [boletins, setBoletins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagina, setPagina] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const limite = 20;

  // ============================
  // Função para carregar boletins
  // ============================
  const carregarBoletins = useCallback(async () => {
    try {
      setLoading(true);

      const { data } = await api.get("/incidentReport");

      // paginação
      const total = data.length;
      setTotalPaginas(Math.ceil(total / limite));

      const inicio = (pagina - 1) * limite;
      const fim = inicio + limite;

      setBoletins(data.slice(inicio, fim));
    } catch (err) {
      console.error("Erro ao buscar boletins", err);
      alert("Erro ao carregar boletins.");
    } finally {
      setLoading(false);
    }
  }, [pagina]);

  useEffect(() => {
    carregarBoletins();
  }, [carregarBoletins]);

  // ============================
  // Função para excluir boletim
  // ============================
  const excluirBoletim = async (id) => {
    if (!window.confirm("Confirma excluir este boletim?")) return;

    try {
      await api.delete(`/incidentReport/remove/${id}`);

      alert("Boletim excluído com sucesso.");
      carregarBoletins();
    } catch (err) {
      console.error("Erro ao excluir:", err);
      alert("Erro ao excluir boletim.");
    }
  };

  // ============================
  // Renderização
  // ============================
  return (
    <div style={{ padding: "20px" }}>
      <h2>Lista de Boletins</h2>

      {loading ? (
        <p>Carregando...</p>
      ) : (
        <>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Número</th>
                <th>Data</th>
                <th>Natureza</th>
                <th>Ações</th>
              </tr>
            </thead>

            <tbody>
              {boletins.map((item) => (
                <tr key={item._id} style={{ borderBottom: "1px solid #ccc" }}>
                  <td>{item._id}</td>
                  <td>{item.numero}</td>
                  <td>{item.data}</td>
                  <td>{item.natureza}</td>
                  <td>
                    {hasPermission("boletins.delete") && <button
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onClick={() => excluirBoletim(item._id)}
                    >
                      Excluir
                    </button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Paginação */}
          <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
            <button
              disabled={pagina === 1}
              onClick={() => setPagina((p) => p - 1)}
            >
              ◀ Voltar
            </button>

            <span>
              Página {pagina} de {totalPaginas}
            </span>

            <button
              disabled={pagina === totalPaginas}
              onClick={() => setPagina((p) => p + 1)}
            >
              Avançar ▶
            </button>
          </div>
        </>
      )}
    </div>
  );
}
